module.exports = __webpack_public_path__ + "static/media/logo.e0c729b4.png";